/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IntegrationsResourceControllerFindAllQueryResponse, IntegrationsResourceControllerFindAllQueryParams, IntegrationsResourceControllerFindAll401, IntegrationsResourceControllerFindAll403 } from "../../models/integrationsController/IntegrationsResourceControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { integrationsResourceControllerFindAll } from "../../clients/integrationsService/integrationsResourceControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const integrationsResourceControllerFindAllQueryKey = (params: IntegrationsResourceControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/integrations'
}, ...(params ? [params] : [])] as const;
export type IntegrationsResourceControllerFindAllQueryKey = ReturnType<typeof integrationsResourceControllerFindAllQueryKey>;
export function integrationsResourceControllerFindAllQueryOptions(params?: IntegrationsResourceControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = integrationsResourceControllerFindAllQueryKey(params);
  return queryOptions<IntegrationsResourceControllerFindAllQueryResponse, ResponseErrorConfig<IntegrationsResourceControllerFindAll401 | IntegrationsResourceControllerFindAll403>, IntegrationsResourceControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return integrationsResourceControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List integrations
 * {@link /api/v1/integrations}
 */
export function useIntegrationsResourceControllerFindAll<TData = IntegrationsResourceControllerFindAllQueryResponse, TQueryData = IntegrationsResourceControllerFindAllQueryResponse, TQueryKey extends QueryKey = IntegrationsResourceControllerFindAllQueryKey>(params?: IntegrationsResourceControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<IntegrationsResourceControllerFindAllQueryResponse, ResponseErrorConfig<IntegrationsResourceControllerFindAll401 | IntegrationsResourceControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? integrationsResourceControllerFindAllQueryKey(params);
  const query = useQuery({
    ...integrationsResourceControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<IntegrationsResourceControllerFindAll401 | IntegrationsResourceControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}